import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { status: String }

  connect() {
    if (this.shouldPoll) {
      this.startPolling()
    }
  }

  disconnect() {
    this.stopPolling()
  }

  get shouldPoll() {
    return this.statusValue === "pending" || this.statusValue === "generating"
  }

  startPolling() {
    this.timer = setInterval(() => this.poll(), 5000)
  }

  stopPolling() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  async poll() {
    try {
      const response = await fetch(window.location.href, {
        headers: { "Accept": "text/html" }
      })

      if (!response.ok) return

      const html = await response.text()
      const parser = new DOMParser()
      const doc = parser.parseFromString(html, "text/html")
      const newContent = doc.querySelector(`[data-controller="report-polling"]`)

      if (!newContent) return

      const newStatus = newContent.dataset.reportPollingStatusValue
      if (newStatus !== this.statusValue) {
        this.element.outerHTML = newContent.outerHTML
      }
    } catch {
      // Silently ignore network errors, will retry on next interval
    }
  }
}
